import axiosClient from './axiosClient';

const BanDoDeXuatApi = {

    getAllDanhMuc: () => {
        const url = '/bandodexuat/getalldanhmuc';
        return axiosClient.get(url);
    },
    getDetail: (params) => {
        const url = '/bandodexuat/getbyid';
        return axiosClient.get(url, { params });
    },
    update: (data) => {
        const url = '/bandodexuatsudungdat/edit';
        return axiosClient.put(url, data);
    },
    add: (params) => {
        const url = '/bandodexuat/add';
        return axiosClient.post(url, params);
    },
    getPaging: (params) => {
        const url = '/bandodexuat/getpaging';
        return axiosClient.get(url, { params });
    },
    getPaging: (params) => {
        const url = '/mappublic/gettimkiem';
        return axiosClient.get(url, { params });
    }

}

export default BanDoDeXuatApi;